import { call, put, takeLatest } from "redux-saga/effects";
import { axiosInstance } from "utils/axios";
import { AxiosResponse } from "axios";
import { actions } from "./maintenanceSlice";
import { MaintenanceApi } from "services/code-gen/openapi/Api/api";
import { IAppMaintenance } from "./maintenanceTypes";

const maintenanceApi = new MaintenanceApi(
  undefined,
  process.env.REACT_APP_API_ROOT,
  axiosInstance
);

function* workMaintenanceCheck(
  action: ReturnType<typeof actions.getMaintenanceCheck>
) {
  try {
    const response: AxiosResponse<IAppMaintenance> = yield call(() =>
      maintenanceApi.appMaintenanceGet()
    );
    yield put(actions.getMaintenanceCheckSuccess(response.data));
  } catch (error) {
    yield put(actions.getMaintenanceCheckFailure(error));
  }
}

const MaintenanceSaga = [
  takeLatest(actions.getMaintenanceCheck, workMaintenanceCheck),
];

export default MaintenanceSaga;
